import React from 'react';
import { Link } from 'react-router-dom';
import {Sunset, Utensils, Wifi, Coffee, Droplet,Snowflake} from 'lucide-react';
import Testimonial from '../components/Testimonial';
import { useInView } from 'react-intersection-observer';
import HeroImage from '../Resources/WhatsApp Image 2025-05-09 at 09.16.37.jpeg';
import AboutImage from '../Resources/WhatsApp Image 2025-05-09 at 09.16.37 (1).jpeg';
import casa_spate1 from '../Resources/casa_spate1.jpg';
import spate_casa2 from '../Resources/spate_casa2.jpg';
import spate_casa4 from '../Resources/spate_casa4.jpg';
import terasa_1 from '../Resources/terasa_1.jpg';
import terasa_2 from '../Resources/terasa_2.jpeg';
import intrare1 from '../Resources/intrare.jpeg';
import intrare2 from '../Resources/intrare2.jpg';
import sufragerie1 from '../Resources/sufragerie1.jpg';
import sufragerie2 from '../Resources/sufragerie2.jpg';
import bucatarie from '../Resources/bucatarie.jpeg';
import gratar2 from '../Resources/gratar2.jpg';
import masa_pingpong from '../Resources/masa_pingpong.jpg';








const HomePage: React.FC = () => {
  const { ref: featuresRef, inView: featuresInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const { ref: testimonialsRef, inView: testimonialsInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const { ref: galleryRef, inView: galleryInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const galleryImages = [
    {
      url: casa_spate1,

    },
    {
      url: spate_casa2,
    },
    {
      url: spate_casa4,
    },
    {
      url: terasa_1,
    },
    {
      url: terasa_2,
    },
    {
      url: gratar2,
    },
    {
      url: masa_pingpong,
    },
    {
      url: intrare1,
    },
    {
      url: intrare2,
    },
    {
      url: sufragerie1,
    },
    {
      url: sufragerie2,
    },
    {
      url: bucatarie,
    },


  ];
  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <section className="h-screen relative flex items-center justify-center">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${HeroImage})`,
          }}
        >
          <div className="absolute inset-0 bg-black opacity-40"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-4 animate-fadeIn">
            Bine ați venit la Casa Leahu
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-2xl mx-auto animate-fadeIn animation-delay-200">
            Experimentați confortul și liniștea în stațiunile 1Mai-Băile Felix
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 animate-fadeIn animation-delay-400">
            <Link
              to="/rooms"
              className="px-8 py-3 bg-sage-700 hover:bg-sage-800 text-white rounded-md transition-colors shadow-lg text-lg font-medium"
            >
              Vizualizați camerele
            </Link>
            <Link
              to="/book"
              className="px-8 py-3 bg-transparent hover:bg-white/10 text-white border-2 border-white rounded-md transition-colors shadow-lg text-lg font-medium"
            >
              Rezervați
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-sage-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-center">
            <div className="w-full md:w-1/2 mb-10 md:mb-0">
              <div className="relative">
                <img
                    src={AboutImage}
                  alt="Casa Leahu Exterior"
                  className="rounded-lg shadow-xl z-10 relative"
                />
                <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-sage-200 rounded-lg -z-0 hidden md:block"></div>
              </div>
            </div>
            <div className="w-full md:w-1/2 md:pl-16">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-800 mb-6">
                Locul perfect pentru vacanța dumneavoastră!
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                "Închiriem camere în regim hotelier în proximitatea Ștrandurilor din Băile 1 Mai.Camerele sunt duble cu pat matrimonial ,băi proprii aer condiționat și balcoane sau terase.Dispunem de o zona de living spațioasă ,o bucătărie dotată și utilată ,inclusiv mașină de spălat vase.Terasele vă oferă condiții pentru petrecerea unor seri de neuitat .Locația dispune de o curte generoasă cu mult spațiu verde iluminată ambiental cu panou de basket și masa de tenis .In incintă exista un barbeque modern care este la dispoziția dumneavoastră.Locația este situată la aproximativ 200 m de Aquaparkul Perla, la 350 de Strandul cu Valuri , la aproximativ 500 m de ștrandul Venus și la aproximativ 1 km de Băile Felix.Acceptăm carduri de vacanta UP și EDENRED."
              </p>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Indiferent dacă explorați zona locală sau căutați o evadare liniștită, serviciul nostru atent și camerele confortabile oferă baza perfectă pentru călătoria dumneavoastră.
              </p>
              <Link
                to="/contact"
                className="px-6 py-3 bg-terracotta-500 hover:bg-terracotta-600 text-white rounded-md transition-colors shadow-md inline-block"
              >
                Vezi mai multe
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Gallery Section */}
      <section
          ref={galleryRef}
          className="py-20 bg-white"
      >
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-800 mb-3">
              Galerie Foto
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Explorați Casa Leahu prin intermediul fotografiilor noastre
            </p>
          </div>

          <div
              className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-500 ${
                  galleryInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
          >
            {galleryImages.map((image, index) => (
                <div
                    key={index}
                    className="relative group overflow-hidden rounded-lg shadow-lg aspect-[4/3]"
                >
                  <img
                      src={image.url}

                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">

                  </div>
                </div>
            ))}
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section
        ref={featuresRef}
        className="py-20 bg-white"
      >
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-800 mb-3">
            Facilitățile noastre
          </h2>
          <p className="text-gray-600 mb-16 max-w-2xl mx-auto">
            Bucurați-vă de facilitățile noastre atent selectate, concepute pentru confortul dumneavoastră.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: <Wifi className="h-10 w-10 text-sage-600 mb-4" />, title: "WiFi gratuit", description: "Rămâneți conectat cu internetul de mare viteză 5G gratuit.\n" },
              { icon: <Sunset className="h-10 w-10 text-sage-600 mb-4" />, title: "Priveliste", description: "Bucurați-vă de vederi frumoase din camera dvs." },
              { icon: <Droplet className="h-10 w-10 text-sage-600 mb-4" />, title: "Baie privată", description: "Fiecare cameră dispune de baie privată" },
              { icon: <Utensils className="h-10 w-10 text-sage-600 mb-4" />, title: "Bucătărie", description: "Le punem la dispoziție oaspeților noștri o bucătărie complet utilată" },
              { icon: <Coffee className="h-10 w-10 text-sage-600 mb-4" />, title: "Cafea", description: "Oferim cafea din partea casei oaspeților noștri" },
              { icon: <Snowflake className="h-10 w-10 text-sage-600 mb-4" />, title: "Aer condiționat", description: "Toate camerele dispun de aer condiționat." },
            ].map((feature, index) => (
              <div
                key={index}
                className={`bg-white p-8 rounded-lg shadow-md transition-all duration-500 transform hover:-translate-y-2 ${
                  featuresInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="flex justify-center">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section
        ref={testimonialsRef}
        className="py-20 bg-sage-50"
      >
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-800 mb-3">
              Recenziile oaspeților
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Vezi ce au de spus oaspeții noștri despre șederea lor la Casa Leahu.
            </p>
          </div>

          <div
            className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-500 ${
              testimonialsInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <Testimonial
              quote="Pensiune perfect utilata, aflata la distanta mica de strandurile Venus, Perla, si de parc . Gazda amabila, cafea bună (oferită). Culori plăcute în camere, bai,etc. Vom reveni cu drag"
              name="Maria"
              title="Romania"
              avatar="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            />
            <Testimonial
              quote="Locația frumoasă.Verdeață,flori, curățenie,gazde zâmbitoare, locația dotată cu tot ce trebuia.Nu am avut nimic de reproșat."
              name="Natalia"
              title="Romania"
              avatar="https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            />
            <Testimonial
              quote="Locația nouă, bucatarie si loc de servit masa, curte îngrijită, loc de grătar. Camera si baia curate, balcon cu o măsuță și 2 scaune. Pe hol lângă cameră un minibar, în bucătărie cafea din partea casei. Proprietarii foarte amabili și atenți la detalii."
              name="Petru"
              title="Romania"
              avatar="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-sage-700 text-white">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6">
            Sunteți gata să vă rezervați sejurul?
          </h2>
          <p className="text-xl max-w-2xl mx-auto mb-8 text-sage-100">
            Experimentați confortul și liniștea din Casa Leahu.
          </p>
          <Link
            to="/book"
            className="px-8 py-3 bg-white text-sage-700 hover:bg-sage-100 rounded-md transition-colors shadow-lg text-lg font-medium inline-block"
          >
            Rezerva acum
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;